import{useState}from'react'
import{supabase}from'../supabase'
export default function DealForm({eventId,deal,onSaved}){
const[dealType,setDealType]=useState(deal?.deal_type||'flat_guarantee')
const[guarantee,setGuarantee]=useState(deal?.guarantee_amount||'')
const[doorPct,setDoorPct]=useState(deal?.door_percentage||'')
const[travel,setTravel]=useState(deal?.travel_covered||false)
const[travelCap,setTravelCap]=useState(deal?.travel_cap||'')
const[hospitality,setHospitality]=useState(deal?.hospitality_buyout||'')
const[comps,setComps]=useState(deal?.comp_tickets||'')
const[saving,setSaving]=useState(false)
async function handleSave(){
setSaving(true)
const payload={event_id:eventId,deal_type:dealType,guarantee_amount:parseFloat(guarantee)||0,door_percentage:parseFloat(doorPct)||0,travel_covered:travel,travel_cap:parseFloat(travelCap)||0,hospitality_buyout:parseFloat(hospitality)||0,comp_tickets:parseInt(comps)||0}
if(deal){await supabase.from('deals').update(payload).eq('event_id',eventId)}
else{await supabase.from('deals').insert([payload])}
setSaving(false)
onSaved()}
return(<div>
<div style={{marginBottom:'12px'}}>
<label style={{fontSize:'12px',color:'#888',display:'block',marginBottom:'4px'}}>Deal Type</label>
<select value={dealType} onChange={e=>setDealType(e.target.value)} className='input'>
<option value='flat_guarantee'>Flat Guarantee</option>
<option value='vs_door'>Vs Door</option>
<option value='door_deal'>Door Deal</option>
<option value='co_promotion'>Co-Promotion</option>
</select></div>
<div style={{marginBottom:'12px'}}>
<label style={{fontSize:'12px',color:'#888',display:'block',marginBottom:'4px'}}>Guarantee Amount ($)</label>
<input className='input' type='number' placeholder='0.00' value={guarantee} onChange={e=>setGuarantee(e.target.value)}/></div>
<div style={{marginBottom:'12px'}}>
<label style={{fontSize:'12px',color:'#888',display:'block',marginBottom:'4px'}}>Door Percentage (%)</label>
<input className='input' type='number' placeholder='0' value={doorPct} onChange={e=>setDoorPct(e.target.value)}/></div>
<div style={{marginBottom:'12px',display:'flex',alignItems:'center',gap:'8px'}}>
<input type='checkbox' checked={travel} onChange={e=>setTravel(e.target.checked)} id='travel'/>
<label htmlFor='travel' style={{fontSize:'14px'}}>Travel Covered</label></div>
<div style={{marginBottom:'12px'}}>
<label style={{fontSize:'12px',color:'#888',display:'block',marginBottom:'4px'}}>Travel Cap ($)</label>
<input className='input' type='number' placeholder='0.00' value={travelCap} onChange={e=>setTravelCap(e.target.value)}/></div>
<div style={{marginBottom:'12px'}}>
<label style={{fontSize:'12px',color:'#888',display:'block',marginBottom:'4px'}}>Hospitality Buyout ($)</label>
<input className='input' type='number' placeholder='0.00' value={hospitality} onChange={e=>setHospitality(e.target.value)}/></div>
<div style={{marginBottom:'20px'}}>
<label style={{fontSize:'12px',color:'#888',display:'block',marginBottom:'4px'}}>Comp Tickets</label>
<input className='input' type='number' placeholder='0' value={comps} onChange={e=>setComps(e.target.value)}/></div>
<button className='btn-primary' onClick={handleSave} disabled={saving}>{saving?'Saving...':'Save Deal Terms'}</button>
</div>)}